import React from 'react';

import Placeholder from '../components/placeholder';

import profile from '../imgs/profile.jpg';

class Profile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rec_count: 23
        }
    }
    onHandleClickRec () {
        this.setState({rec_count: this.state.rec_count+1})
    }
    render () {
        return (
            <div className="container frame">
                <div className="profile-container d-flex">
                    <div className="profile-thumbnail">
                        <img src={profile} />
                    </div>
                    <div className="profile-info">
                        <h1 className="profile-name">James Warren</h1>
                        <span>
                            <i className="fas fa-star fa-lg"></i>
                            <i className="fas fa-star fa-lg"></i>
                            <i className="fas fa-star fa-lg"></i>
                            <i className="fas fa-star fa-lg"></i>
                            <i className="far fa-star fa-lg"></i>
                        </span>
                        <div className="profile-stat">
                            <small>1 verifications</small> &middot; <small>{this.state.rec_count} recommends</small>
                        </div>
                    </div>
                </div>
                <hr/>
                <div className="row">
                    <div className="col-sm-5 col-md-4 col-lg-3">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">About</h5>
                            <hr/>
                            <div className="profile-infobox-item flex-space-between">
                                <div className="profile-infobox-label">
                                    School
                                </div>
                                <div className="profile-infobox-detail">
                                    Seneca
                                </div>
                            </div>
                            <div className="profile-infobox-item flex-space-between">
                                <div className="profile-infobox-label">
                                    Program
                                </div>
                                <div className="profile-infobox-detail">
                                    PRA
                                </div>
                            </div>
                            <div className="profile-infobox-item flex-space-between">
                                <div className="profile-infobox-label">
                                    Language
                                </div>
                                <div className="profile-infobox-detail">
                                    English, Spanish
                                </div>
                            </div>
                            <div className="profile-infobox-item">
                                <div className="profile-infobox-label">
                                    Description
                                </div>
                                <div className="profile-infobox-detail profile-infobox-description-detail">
                                    Clean and fun. I just do magic 24-7. Abracadabra!
                                </div>
                            </div>
                            <div className="profile-infobox-item">
                                <button className="btn btn-primary btn-block btn-recommend"
                                    onClick={this.onHandleClickRec.bind(this)}
                                    >Recommend</button>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div className="col-sm-7 col-md-8 col-lg-9">
                        <h4>Property</h4>
                        <hr/>
                        <Placeholder message={'No properties'} />
                        <h4>Reviews</h4>
                        <hr/>
                        <Placeholder message={'No reviews'} />
                    </div>
                </div>

            </div>
        )
    }
}

export default Profile;